import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Profile} from '../../pages/settings/profile/profile.model';

export interface ProfileRequestParam {
    id: number;
    name: string;
    maxTemperature: string;
    minTemperature: string;
    tolerance: string;
    status: string;
    statusId: number;
}

@Injectable()
export class ProfileService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

    // fetch All Profile
    getAllProfile(pageNumber: any, limit: any): Observable<any> {
        const me = this;
        const profileListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
      /*  params = params.append('s', '0');*/
        me.apiRequest.get(this.appConfig.profile_url, params).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                    maxTemperature: `${v.maxTemperature}`,
                    minTemperature: `${v.minTemperature}`,
                    tolerance: `${v.tolerance}`,
                    statusId: `${v.statusId}`,
                    status: `${v.status}`,
                });
            });

            const coldObj = Object.assign({}, jsonResp, {
                data: items
            });
            profileListSubject.next(coldObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return profileListSubject;
    }

    /*// fetch All Barns By Id
    getBarnsById(id: any): Observable<any> {
        return this.apiRequest.get(this.appConfig.barns_url + '/' + id + '/pick-details/latest');
    }*/

    // update profile
    update(profile: Profile, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': profile.id,
            'name': profile.name,
            'maxTemperature': profile.maxTemperature,
            'minTemperature': profile.minTemperature,
            'tolerance': profile.tolerance,
            'status': profile.status

        };

        const profileDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.profile_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let profileInfoReturn: ProfileRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const cc: Profile = jsonResp.data[0];
                        profileInfoReturn = <ProfileRequestParam>{
                            'id': cc.id,
                            'name': cc.name,
                            'maxTemperature': cc.maxTemperature,
                            'minTemperature': cc.minTemperature,
                            'tolerance': profile.tolerance,
                            'status': cc.status
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    profileDataSubject.next(profileInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return profileDataSubject;
    }

    // save profile
    save(profile: Profile): Observable<any> {
        const me = this;

        const bodyData: ProfileRequestParam = <ProfileRequestParam>{
            'id': profile.id,
            'name': profile.name,
            'maxTemperature': profile.maxTemperature,
            'minTemperature': profile.minTemperature,
            'tolerance': profile.tolerance,
            'status': profile.status

        };

        const profileDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.profile_url, bodyData)
            .subscribe(jsonResp => {
                    let profileInfoReturn: ProfileRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const profile: Profile = jsonResp.data[0];

                        profileInfoReturn = <ProfileRequestParam>{
                            'id': profile.id,
                            'name': profile.name,
                            'maxTemperature': profile.maxTemperature,
                            'minTemperature': profile.minTemperature,
                            'tolerance': profile.tolerance,
                            'status': profile.status
                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    profileDataSubject.next(profileInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return profileDataSubject;
    }

    deleteProfile(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.profile_url + '/' + id);
    }

    getProfileDD() {
        const me = this;
        return me.apiRequest.get(this.appConfig.profile_dd_url);
    }

}
